import React from "react";
import {Box, Chip} from "@mui/material";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import {BasicWordWithId} from "../../../../../common/types/words";

export interface SynonymsViewProps {
    synonyms?: BasicWordWithId[];
    onSynonymClick?: (synonym: BasicWordWithId) => void;
}

export default function SynonymsView({synonyms, onSynonymClick}: SynonymsViewProps) {

    if (!synonyms || synonyms.length === 0) {
        return null;
    }

    const chipSx = {
        ml: 0.5,
        mt: 0,
        borderColor: 'secondary.main',
        color: 'secondary.contrastText',
        backgroundColor: 'secondary.main',
        '& .MuiChip-deleteIcon': {
            color: 'black',
        },
    } as const;

    return (
        <ListItemReversedTextView
            title="Synonyms"
            content={(
                <Box sx={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 0.5, rowGap: 0.5, columnGap: 0.5}}>
                    {synonyms.map((synonym, index) => (
                        <Chip
                            key={`${synonym.wordId}-${synonym.lemma}-${index}`}
                            label={synonym.lemma}
                            size="small"
                            sx={chipSx}
                            onClick={() => onSynonymClick?.(synonym)}
                        />
                    ))}
                </Box>
            )}
        />
    );
}
